import Call from "../service/axios";
import {trackPromise} from "react-promise-tracker";
import arrayUniq from "array-uniq";

const getSearchOptions = async (url, fieldName, trackThisPromise = true) => {
  const SearchUrl = `${url}search/?field=${fieldName}`;
  let response;
  if (trackThisPromise) {
    response = await trackPromise(Call.get(SearchUrl));
  } else {
    response = await Call.get(SearchUrl);
  }
  const {data} = response;
  //filtering for empty string
  let filteredData = await data.filter((value) => !!value);
  //removing duplicate entries
  let results = await arrayUniq(filteredData);
  let responseOptions = await results?.map((data) => {
    return {label: data.toString(), value: data.toString()};
  });

  return responseOptions;
};

export default getSearchOptions;
